import * as Sentry from '@sentry/react'
import { Component, ErrorInfo, ReactNode } from 'react'

interface Props {
  children: ReactNode
  fallback?: ReactNode
}

interface State {
  hasError: boolean
  error: Error | null
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { hasError: false, error: null }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error }
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    Sentry.captureException(error, {
      extra: { componentStack: info.componentStack },
    })
  }

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) return this.props.fallback

      return (
        <div className="w-full h-[100dvh] flex flex-col items-center justify-center gap-4 bg-white text-purple px-6 text-center">
          <p className="text-lg font-semibold">Something went wrong</p>
          <p className="text-sm text-grey5">
            Please refresh the page or contact support if the issue persists.
          </p>
          <button
            className="mt-4 px-6 py-2 rounded-full border border-purple text-purple text-sm"
            onClick={() => this.setState({ hasError: false, error: null })}
          >
            Try again
          </button>
        </div>
      )
    }

    return this.props.children
  }
}
